export const ConstantsOdia = {
    patterns: [
        {
            "search_word":"ଡ଼",
            "replace_word": "ଡ଼"
        },
        {
            "search_word":"ଢ଼",
            "replace_word":"ଢ଼"
        },
        {
            "search_word":"ଡ଼ା",
            "replace_word":"ଡ଼ା"
        },
		 {
            "search_word":"ଢ଼ା",
            "replace_word":"ଢ଼ା"
        },
		  {
            "search_word":"ଡ଼ି",
            "replace_word":"ଡ଼ି"
        },
        {
            "search_word":"ଢ଼ି",
            "replace_word":"ଢ଼ି"
        },
        {
            "search_word":"ଡ଼ୋ",
            "replace_word":"ଡ଼ୋ"
        },
        {
            "search_word":"ଢ଼ୋ",
            "replace_word":"ଢ଼ୋ"
        },
    ],
	//replacement while copying
    fix_patterns: [
        {
            "search_word":"ଡ଼",
            "replace_word": "ଡ଼"
        },
        {
           "search_word":"ଢ଼",
            "replace_word":"ଢ଼"
        },
    ],
    variations:
    {
        // বিকল্প আখৰ আৰু শব্দৰ তালিকা।
        //"বিকল্পটো":"মূলটো" (মূলটো আছে, বিকল্পে ইটোও শুদ্ধ -এই কনচেপ্ট।// থকাটো যিকোনো এফালে //দিব লাগিব)
        "ର୍ଚ": "ର୍ଚ୍ଚ",
		"ର୍ଜ": "ର୍ଜ୍ଜ",
		"ର୍ଣ": "ର୍ଣ୍ଣ",
        "ର୍ତ": "ର୍ତ୍ତ",
        "ର୍ଦ": "ର୍ଦ୍ଦ",
		"ର୍ବ": "ର୍ବ୍ବ",
        "ର୍ମ": "ର୍ମ୍ମ",
        "ଡ଼": "ଡ଼",
        "ଢ଼": "ଢ଼",
		"ପରୀକ୍ଷା": "ସମ୍ପରୀକ୍ଷା",
		"ପକ୍ଷୀ": ["জিহাদ"],
		"ମୁଚଲିମ": ["ମୁଚଲମାନ", "ମଚଲମାନ", "ମଚଲିମ"],
	"କୃଷି": ["କୃଷିଖଣ୍ଡ", "ଉଦ୍ୟୋଗଖଣ୍ଡ"],
	"ଇଲେକଟ୍ରନ": ["ପ୍ରଟନ", "ଇଲେକଟ୍ରୋନ","ପ୍ରୋଟନ"],
    },
    suggestion_replacement: {
         "ଡ": "ଡ଼",
		"ଢ": "ଢ଼",
		"ଯ": "ୟ",
		"ୟ": "ଯ"
		}
}